import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

// atomic components
import AccountButton from 'components/atoms/AccountButton'

const EligibleActions = props => {
  const { camper, camperSession, showName=true } = props
  const { firstName } = camper
  const { session } = camperSession

  return (
    <AccountButton
      component={Link}
      variant='contained'
      color='secondary'
      to={`/express_check_in/campers/${camper.id}/sessions/${session.id}`}
      fullWidth
    >
      Express Check In {showName && firstName}
    </AccountButton>
  )
}

EligibleActions.propTypes = {
  camper: PropTypes.object.isRequired,
  camperSession: PropTypes.object.isRequired
}

export default EligibleActions
